import {
  doesSeasonHaveBrandkit,
  getEndpointForGetUserHasSeenSeasonalBrandkit,
  getEndpointForSetUserHasSeenSeasonalBrandkit,
  isSeasonCurrentlyActive,
  isSeasonalBrandkitPopoverEnabled,
} from '@Libraries/seasonal-brandkit-popover.library';
import {useEffect, useState} from 'react';
import type {SeasonName} from '@Libraries/seasons.library';

const HIDDEN_POPOVER_STATE: [boolean, () => Promise<void>] = [false, (): Promise<void> => Promise.resolve()];

export function useShowSeasonalBrandkitPopover(season: SeasonName | undefined): [boolean, () => Promise<void>] {
  const [showSeasonalBrandkitPopover, setShowSeasonalBrandkitPopover] = useState(false);

  const init = (): void => {
    void initUserHasSeenSeasonalBrandkitPopoverStatus();
  };

  useEffect(() => {
    if (!isSeasonalBrandkitPopoverEnabled()) {
      return;
    }

    if (!season || !isSeasonCurrentlyActive(season)) {
      return;
    }

    if (!doesSeasonHaveBrandkit(season)) {
      return;
    }

    init();
  }, [season]);

  if (!season) {
    return HIDDEN_POPOVER_STATE;
  }

  if (!doesSeasonHaveBrandkit(season)) {
    return HIDDEN_POPOVER_STATE;
  }

  const getUserHasSeenSeasonalBrandkitPopover = async (): Promise<boolean> => {
    return !!(await window.PMW.readLocal(getEndpointForGetUserHasSeenSeasonalBrandkit(season)));
  };

  const markUserHasSeenSeasonalBrandkitPopover = async (): Promise<void> => {
    try {
      await window.PMW.writeLocal(getEndpointForSetUserHasSeenSeasonalBrandkit(season));
    } catch (e) {
      console.error(`Error setting user has seen brandkit popover for ${season}. Details:`, e);
    }

    setShowSeasonalBrandkitPopover(false);
  };

  const initUserHasSeenSeasonalBrandkitPopoverStatus = async (): Promise<void> => {
    try {
      const response = await getUserHasSeenSeasonalBrandkitPopover();
      setShowSeasonalBrandkitPopover(!response);
    } catch {
      setShowSeasonalBrandkitPopover(false);
    }
  };

  return [showSeasonalBrandkitPopover, markUserHasSeenSeasonalBrandkitPopover];
}
